import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import { MODAL_FORM_WRAPPER_CLASSNAME, renderPlayerPreviewForm } from 'video-embed/utils/overlay';
import { PlayerStatus } from '../constants';
import ModalOverlay from './ModalOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class FormModal extends PureComponent {
  constructor(...args) {
    super(...args);
    this.formWrapperRef = null;
    this.state = {
      showingInlineMessage: false
    };
    this.loadForm = () => {
      const {
        conversionAsset,
        video,
        playButtonColor,
        onSkip
      } = this.props;
      if (this.formWrapperRef === null) {
        throw new Error('Error loading form: formWrapperRef is null');
      }
      if (!video) {
        throw new Error('Error loading form: no video found');
      }
      renderPlayerPreviewForm(this.formWrapperRef, conversionAsset, video, {
        playButtonColor
      }, {
        onSubmit: this.handleFormSubmitted,
        onSkip
      }).then(form => {
        this.form = form;
      }).catch(err => {
        console.error('Error rendering preview form', err);
        Raven.captureException(err);
      });
    };
    this.handleFormSubmitted = () => {
      this.setState({
        showingInlineMessage: true
      });
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.status !== prevProps.status && this.props.status === PlayerStatus.CONVERSION_ASSET_OVERLAY) {
      this.loadForm();
    }
  }
  render() {
    const {
      conversionAsset,
      status,
      onSkip,
      onPostSubmit
    } = this.props;
    const {
      showingInlineMessage
    } = this.state;
    const allowClose = !conversionAsset.preventSkip;
    if (status !== PlayerStatus.CONVERSION_ASSET_OVERLAY) {
      return null;
    }
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsxs(ModalOverlay, {
        className: "hsv-form-modal",
        allowClose: allowClose,
        onClose: onSkip,
        children: [/*#__PURE__*/_jsx("div", {
          className: MODAL_FORM_WRAPPER_CLASSNAME,
          ref: formEl => {
            this.formWrapperRef = formEl;
          }
        }), showingInlineMessage &&
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx("div", {
          style: {
            display: 'flex',
            margin: '20px 0',
            justifyContent: 'center'
          },
          children: /*#__PURE__*/_jsx(VizExButton, {
            onClick: onPostSubmit,
            use: "primary",
            "data-test-id": "form-watch-video",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "videoPlayer.formModal.inlineMessageButton"
            })
          })
        })]
      })
    );
  }
}
FormModal.propTypes = {
  status: PropTypes.oneOf(Object.values(PlayerStatus)),
  id: PropTypes.string.isRequired,
  conversionAsset: PropTypes.object.isRequired,
  video: PropTypes.object.isRequired,
  playButtonColor: PropTypes.string,
  onSkip: PropTypes.func.isRequired,
  onPostSubmit: PropTypes.func.isRequired
};